import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PulmonologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.6426 40C79.6426 61.8153 61.9578 79.5 40.1426 79.5C18.3273 79.5 0.642578 61.8153 0.642578 40C0.642578 18.1848 18.3273 0.5 40.1426 0.5C61.9578 0.5 79.6426 18.1848 79.6426 40Z'
    />
    <g clipPath='url(#clip0_414_8643)'>
      <path
        d='M17.0117 64.0498C21.7225 68.3398 36.7229 57.3436 36.012 46.5202C30.9513 44.3608 17.0117 53.1821 17.0117 64.0498Z'
        fill='#DB5743'
      />
      <path
        d='M36.0142 38.8041C35.9522 33.3891 36.0142 19.0597 31.0089 21.5026C15.6962 27.7769 13.2777 58.8741 17.0118 64.05C17.0118 53.1822 30.9646 44.3609 36.012 46.5203C36.0142 43.98 36.0253 41.3688 36.0142 38.8041Z'
        fill='#F87670'
      />
      <path
        d='M63.2823 64.0498C58.5737 68.3398 43.5821 57.3436 44.282 46.5202C49.3338 44.3608 63.2823 53.1821 63.2823 64.0498Z'
        fill='#DB5743'
      />
      <path
        d='M44.2732 38.8041C44.3308 33.3891 44.2732 19.0597 49.2763 21.5026C64.589 27.7769 67.0075 58.8741 63.2823 64.05C63.2823 53.1822 49.3295 44.3609 44.2821 46.5203C44.2732 43.98 44.2533 41.3688 44.2732 38.8041Z'
        fill='#F87670'
      />
      <path
        d='M37.8036 15C38.2405 19.004 38.3723 23.0353 38.1978 27.0593C37.9276 33.0656 30.052 38.6911 26.3379 40.2658L29.062 42.2015C39.9851 35.8894 40.4502 35.9072 51.36 42.2015L54.1705 40.2658C50.4542 38.6977 42.583 33.0656 42.3261 27.0593C42.1428 23.0358 42.2687 19.0042 42.7026 15L37.8036 15Z'
        fill='#FFBD66'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_8643'>
        <rect width='50' height='50' fill='white' transform='translate(15.1426 15)' />
      </clipPath>
    </defs>
  </svg>
));
PulmonologyIcon.displayName = 'PulmonologyIcon';

export default PulmonologyIcon;
